export interface IMapExpose {
  centerCameraToClusterBounds(): void;
  centerCameraToFrance(): void;
  centerCameraToPoint(point: IMapPoint): void;
  zoom(direction: EZoomDirection): void;
}

export interface IMapPoint {
  lat: number;
  lng: number;
}

export enum EZoomDirection {
  IN = "IN",
  OUT = "OUT",
}
